import React, { useState, useEffect, useCallback } from "react";
import { VoiceRecorder } from "capacitor-voice-recorder";

const initialState = {
  recordingMinutes: 0,
  recordingSeconds: 0,
  isRecording: false,
  audio: null,
};

const useRecorder = () => {
        const [recorder, setRecorder] = useState(initialState);

        // Callback function to stop recording, it is wrapped in useCallback to avoid stale closure issues in useEffect
        const stopRecording = () => {
        //  console.log({ recorder });
          if (!recorder?.isRecording) {
            return;
          } else {
            console.log("stopRecording");
            VoiceRecorder.stopRecording()
              .then(async ({ value }) => {
                console.log({ value });
                try {
                  if (value && value.recordDataBase64) {
                    const recordData = value.recordDataBase64;

                    const recordUrl = `data:${
                      value.mimeType
                    };base64,${recordData}`;
                    const base64Response = await fetch(recordUrl);
                    const blob = await base64Response.blob();

                    setRecorder(state => ({
                      ...state,
                      isRecording: false,
                      audio: blob,
                      duration: value?.msDuration || 0,
                    }));
                  }
                } catch (error) {
                  console.error(
                    "Error while stopping recording: ",
                    error,
                  );
                }
              })
              .catch(err => {
                console.error("Error while stopping recording: ", err);
              });
          }
        }; // stopRecording depends on recorder.isRecording

        useEffect(() => {
          const MAX_RECORDER_TIME = 5;
          let recordingInterval = null;

          if (recorder.isRecording) {
            recordingInterval = setInterval(() => {
              setRecorder(prevState => {
                let newMinutes = prevState.recordingMinutes;
                let newSeconds = prevState.recordingSeconds;

                // If max time is reached, stop recording
                if (
                  newMinutes === MAX_RECORDER_TIME &&
                  newSeconds === 0
                ) {
                  clearInterval(recordingInterval);
                  stopRecording();
                  newSeconds = MAX_RECORDER_TIME * 60;
                } else if (newSeconds < 59) {
                  // Otherwise, increment seconds
                  newSeconds++;
                } else if (newSeconds === 59) {
                  // If seconds reach 59, reset seconds and increment minutes
                  newMinutes++;
                  newSeconds = 0;
                }

                return {
                  ...prevState,
                  recordingMinutes: newMinutes,
                  recordingSeconds: newSeconds,
                };
              });
            }, 1000);
          } else {
            clearInterval(recordingInterval);
          }

          return () => {
            clearInterval(recordingInterval);
          };
        }, [recorder?.isRecording, stopRecording]); // useEffect depends on recorder.isRecording and stopRecording

        const startRecording = () => {
          if (recorder?.isRecording) return;

          VoiceRecorder.startRecording()
            .then(({ value }) => {
              setRecorder({ ...initialState, isRecording: true });
            })
            .catch(err => {
              console.error("Error while start recording: ", err);
            });
        };

        const deleteRecording = () => {
          if (!!recorder?.audio) {
            setRecorder(initialState);
          }
        };

        return {
          ...recorder,
          startRecording,
          stopRecording,
          deleteRecording,
        };
      };;

export default useRecorder;
